import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setStepperDisable } from "../../redux/slices/userSlice";
import { showManualContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setStepperDisable(false));

    const timer = setTimeout(() => {
      navigate("/home");
    }, 2000);

    return () => clearTimeout(timer);
  }, [dispatch, navigate]);

  return (
    <div>
      {showManualContextualLoader("Please wait...", 21000)}
      <img src="/images/dashboard.svg" style={{ opacity: 0 }} alt="" />
    </div>
  );
}
